import React from "react";
import { Route, Routes } from "react-router-dom";
import CrewSchedule from "./CrewSchedule";
import MarkHolidays from "./MarkHolidays";

const Schedule = () => {
  return (
    <Routes>
      <Route path="/" element={<CrewSchedule />} />
      <Route path="/set-availability" element={<MarkHolidays />} />
    </Routes>
  );
};

export default Schedule;
